/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BiometryRequest
 */
export interface BiometryRequest {
    /**
     * 
     * @type {string}
     * @memberof BiometryRequest
     */
    biometry?: string;
}

/**
 * Check if a given object implements the BiometryRequest interface.
 */
export function instanceOfBiometryRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BiometryRequestFromJSON(json: any): BiometryRequest {
    return BiometryRequestFromJSONTyped(json, false);
}

export function BiometryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BiometryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'biometry': !exists(json, 'biometry') ? undefined : json['biometry'],
    };
}

export function BiometryRequestToJSON(value?: BiometryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'biometry': value.biometry,
    };
}

